/* eslint-disable camelcase */
import PropTypes from "prop-types";

export const headingSizeProp = PropTypes.oneOf(["large", "default"]);

export const headingTagProp = PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]);

export const headingObjectProp = PropTypes.exact({
    text: PropTypes.string,
    type: headingTagProp,
    is_manual_type: PropTypes.bool,
});

export const headingProp = PropTypes.exact({
    color: PropTypes.string,
    text: PropTypes.array,
    textStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    type: PropTypes.string,
});

export const wysiwygProp = PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.array]));

export const textContentProp = PropTypes.arrayOf(
    PropTypes.oneOfType([
        PropTypes.exact({
            layout: PropTypes.string,
            heading: PropTypes.string,
            headingTag: headingTagProp,
        }),
        PropTypes.exact({
            layout: PropTypes.string,
            text: wysiwygProp,
        }),
    ]),
);

export const cmsTextContentProp = PropTypes.arrayOf(
    PropTypes.oneOfType([
        PropTypes.exact({
            layout: PropTypes.string,
            heading: headingObjectProp,
        }),
        PropTypes.exact({
            layout: PropTypes.string,
            sub_heading: headingObjectProp,
        }),
        PropTypes.exact({
            layout: PropTypes.string,
            ingress: wysiwygProp,
        }),
        PropTypes.exact({
            layout: PropTypes.string,
            paragraph: wysiwygProp,
        }),
    ]),
);
